import React from 'react'

export default function QRCode() {
  return (
    <section>
      <h3>扫码下载懂车帝APP</h3>
      <div className="code" />
      <style jsx>
        {`
          section {
            height: 280px;
            margin-bottom: 10px;
            text-align: center;
            border: 1px solid #ededed;
            background-color: white;
          }
          h3 {
            margin-top: 40px;
            font-size: 14px;
            font-weight: normal;
          }
          .code {
            width: 160px;
            height: 160px;
            margin: 20px auto 0;
            border: solid 1px #e6e6e6;
            background: url(${require('static/dcd-code@3x.png')}) no-repeat left
              top / 100%;
          }
        `}
      </style>
    </section>
  )
}
